export default __webpack_public_path__ + "static/media/howtouse_img_04.54694009.svg";